export const shouldShowCustomInput = (
  currentValue: string,
  lastOptionValue: string,
): boolean => {
  return (
    currentValue === lastOptionValue ||
    (currentValue !== "" && Number(currentValue) > Number(lastOptionValue))
  );
};

export const getValidationErrorMessage = (
  numValue: number,
  minValue: number,
  maxValue: number | undefined,
  currencySymbol: string,
): string => {
  if (numValue <= minValue) {
    return `Please enter a value greater than ${currencySymbol}${minValue.toLocaleString()}`;
  }
  if (maxValue && numValue > maxValue) {
    return `Please enter a value less than ${currencySymbol}${maxValue.toLocaleString()}`;
  }
  return "Please enter a valid amount";
};

export const getCustomDefaultValue = (
  currentValue: string,
  lastOptionValue: string,
): string => {
  return currentValue && Number(currentValue) > Number(lastOptionValue)
    ? currentValue
    : "";
};

export const getDisplayOptions = (
  placeholder: string | undefined,
  options: Array<{ label: string; value: string }>,
): Array<{ label: string; value: string }> => {
  return placeholder
    ? [{ label: placeholder, value: "" }, ...options]
    : options;
};
